<template>
    <div>
        <div>
            <el-table ref="table" :data="tableData" border class="jxzb-tables" @row-click="rowClick">
                <el-table-column type="index" :label="$tx('fields.index', '序号')" width="50" align="center"></el-table-column>
                <el-table-column prop="flSubject" label="纪要标题" align="left" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="flCreator" label="创建人" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="flCreateDept" label="创建部门" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="flCreateDate" label="创建日期" width="150" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="attach" label="纪要文件" align="left" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if="scope.row.passenger&&scope.row.passenger.attachment" style="width:100%;text-wrap: auto;">
                           <el-link type="primary" :underline="false" @click="downloadFile(scope.row.passenger.attachment, 'view')">{{ scope.row.passenger.attachment.fileName }}</el-link>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="option" label="操作" width="80" align="center">
                    <template slot-scope="scope">
                         <el-link v-if="scope.row.passenger&&scope.row.passenger.attachment" type="primary" :underline="false" @click="downloadFile(scope.row.passenger.attachment, 'down')">下载</el-link>
                         <el-link v-else type="primary" disabled :underline="false">下载</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            return moment(val).format('YYYY-MM-DD HH:mm')
        }
    },
    components: {},
    props: {
        row: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            tableData: []
        }
    },
    computed: {},
    watch: {},
    created() {
        // this.$bus.on('meetInfoSeventh', this.meetInfoSeventh)
        this.meetInfoSeventh()
    },
    beforeDestroy() {
        // this.$bus.off('meetInfoSeventh', this.meetInfoSeventh)
    },
    mounted() {},
    methods: {
        meetInfoSeventh() {
            this.getTableData()
        },
        async getTableData() {
            const _this = this
            const data = {
                pageSize: 9999,
                pageNum: 1,
                urlsearch: `meetingId:${this.row.id};status>0;status<9`
            }
            const res = await this.$app.listdata('/hygl/jyap/listdata', data)
            if (res.code === 'success') {
                this.tableData = res.body.pageInfo.list
                this.tableData.forEach(item => {
                    if (item.passenger && item.passenger.attachment) {
                        if (item.passenger.attachment.fileName.indexOf('RedTitle_') > -1) {
                            let attr = item.passenger.attachment.fileName.split('.')
                            item.passenger.attachment.fileName = '会议纪要' + '.' + attr[attr.length - 1]
                        }
                    }
                })
            }
        },
        rowClick(row, column, event) {
            console.log(column)
            if (column.property === 'attach' || column.property === 'option') return

            window.open(`#/wflow?wfEngineUrl=hygl/jyap&busiDataId=${row.id}`)
        },
        downloadFile(attach, type) {
            const url = `/apigw/hygl/jyap/downloadById?inline=true&attachIds=${attach.id}&saveAs=${attach.fileName}&httpPort=${location.port}&fileName=${attach.fileName}`
            if (type === 'view') {
                window.open(url, '_blank')
            } else if (type === 'down') {
                var href = url
                var tempLink = document.createElement('a')// 创建一个a标签
                tempLink.style.display = 'none'
                tempLink.href = encodeURI(href)
                tempLink.setAttribute('download', attach.fileName)// 给a标签添加下载属性
                if (typeof tempLink.download === 'undefined') {
                    tempLink.setAttribute('target', '_blank')
                }
                document.body.appendChild(tempLink)// 将a标签添加到body当中
                console.log('tempLink==', tempLink)
                tempLink.click()// 启动下载
                document.body.removeChild(tempLink)// 下载完毕删除a标签
                href = ''
            }
        }
    }
}
</script>

<style scoped lang="scss">
.dialog_top {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .el-button {
        margin-left: 10px;
        padding: 8px 15px;
    }
}
.contQR {
    width: 372px;
    height: 500px;
    margin: 0 auto;
    h3,
    h4 {
        margin: 0;
    }
    img {
        width: 340px;
        height: 340px;
        margin: 0 auto;
    }
    p {
        margin: 0;
        padding: 0 40px;
        line-height: 22px;
    }
}
</style>
